export default "__VITE_PUBLIC_ASSET__2df4b7d3__"